import { render, staticRenderFns } from "./SupplierDeleteCategoryModal.vue?vue&type=template&id=57d6df56&scoped=true"
import script from "./SupplierDeleteCategoryModal.vue?vue&type=script&lang=js"
export * from "./SupplierDeleteCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierDeleteCategoryModal.vue?vue&type=style&index=0&id=57d6df56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d6df56",
  null
  
)

export default component.exports